var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.813552 0.813341C0.907302 0.719707 1.03438 0.667114 1.16689 0.667114C1.29939 0.667114 1.42647 0.719707 1.52022 0.813341L6.00022 5.29267L10.4802 0.812674C10.5746 0.721639 10.7009 0.6713 10.832 0.672501C10.9631 0.673702 11.0885 0.726345 11.1811 0.819093C11.2738 0.911842 11.3263 1.03727 11.3274 1.16837C11.3285 1.29947 11.278 1.42575 11.1869 1.52001L6.35355 6.35334C6.2598 6.44698 6.13272 6.49957 6.00022 6.49957C5.86772 6.49957 5.74064 6.44698 5.64688 6.35334L0.813552 1.52001C0.767089 1.47357 0.73023 1.41844 0.705083 1.35776C0.679935 1.29707 0.666992 1.23203 0.666992 1.16634C0.666992 1.10065 0.679935 1.03561 0.705083 0.974925C0.73023 0.914242 0.767089 0.859108 0.813552 0.812674V0.813341Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.f72061a8d60311f467f11552fc56153a.svg";
export { ForwardRef as ReactComponent };